import { render, staticRenderFns } from "./CanteenDashboard.vue?vue&type=template&id=3fb4a601&"
import script from "./CanteenDashboard.vue?vue&type=script&lang=js&"
export * from "./CanteenDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports